<template>
    <el-dialog :title="title" :visible.sync="dialog.visible">
        <el-tree
            :load="loadTreeNode"
            :props="treeProps"
            @node-click="clickNode"
            highlight-current
            lazy
        >
            <template slot-scope="{ node }">
                <span style="font-size: 16px;">{{ node.label }}</span>
            </template>
        </el-tree>
        <span slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button @click="handle" type="primary">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { api, post } from '../../service';
import { FILE_DIALOG, FILE_MOVE } from '../../libs/enum.js';

const { mapState, mapActions } = createNamespacedHelpers('resource');

export default {
    data() {
        return {
            treeProps: {
                label: 'name',
                isLeaf: 'leaf',
            },
            current: {},
        };
    },
    computed: {
        ...mapState({
            dialog: state => state.fileDialog,
            selection: state => state.selection,
        }),
        title() {
            return FILE_DIALOG[this.dialog.type];
        },
    },
    methods: {
        ...mapActions(['changeFileDialog', 'moveFiles', 'copyFiles']),
        async loadTreeNode(node, resolve) {
            if (node.level === 0) {
                const data = await this.getLabelList();
                const list = data.labels.map(item => {
                    item.name = item.labelName;
                    return item;
                });
                return resolve(list);
            } else if (node.level === 1) {
                const params = { labelId: node.data.labelId };
                const data = await this.getLabelList(params);
                const list = data.labels.map(item => {
                    item.name = item.labelName;
                    item.leaf = true;
                    return item;
                });
                return resolve(list);
            }
        },
        clickNode(data) {
            this.current = data;
        },
        close() {
            this.changeFileDialog({ visible: false });
        },
        handle() {
            if (this.current.level === 1) {
                return this.$message.error('请选择二级标签！！！');
            }
            const labelFileIds = this.selection.map(item => item.labelFileId);
            const params = {
                labelFileIds: labelFileIds.toString(),
                labelId: this.current.labelId,
            };
            this.dialog.type === FILE_MOVE
                ? this.moveFiles(params)
                : this.copyFiles(params);
        },
        async getLabelList(data) {
            const res = await post(api.resource.labelList, data);
            return res;
        },
        async getFileList(data) {
            const res = await post(api.resource.fileList, data);
            return res;
        },
    },
};
</script>

<style></style>
